import { render, staticRenderFns } from "./PriceExtraUpdate.vue?vue&type=template&id=064e9522&scoped=true"
import script from "./PriceExtraUpdate.vue?vue&type=script&lang=js"
export * from "./PriceExtraUpdate.vue?vue&type=script&lang=js"
import style0 from "./PriceExtraUpdate.vue?vue&type=style&index=0&id=064e9522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e9522",
  null
  
)

export default component.exports